<template>
	<div class="grid pb-0">
		<div class="grid-title-tab">
			<div class="d-grid-title">
				<h4>{{ $t("_BATCH_UPDATE.TITLE") }}</h4>
				<v-btn class="mt-0 mr-2" color="" @click="$router.push({ name: 'roomSaleWithOTAs' })">
					<v-icon light size="20px" left>table_chart</v-icon>
					{{ $t("_ROLES.ROOM_SALE_MANAGEMENT") }}
				</v-btn>
			</div>
			<v-tabs v-model="tab">
				<v-tab v-for="item in tabItems" :key="item.key" :disabled="item.disabled"
					@click="loadRoute(item.routeName)">
					{{ item.title }}
				</v-tab>
			</v-tabs>
		</div>
		<v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
		<div class="grid-body border-top-unset">
			<div>
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";
export default {
	components: {},
	data() {
		return {
			syncPMS: JSON.parse(localStorage.getItem("currentUser")).hotel.syncPMS,
			isLoading: false,
			systemLang: this.$i18n.locale,
			tab: 0,
			syncInventory: JSON.parse(localStorage.getItem("currentUser")).hotel.syncInventory,
		};
	},
	computed: {
		tabItems() {
			return [
				{
					title: this.$t('ROOM_AVAIL'),
					key: 'room-avail',
					disabled: this.syncInventory || this.checkRoleFunc('INVENTORY') === false,
					routeName: "roomAvailUpdate",
					roles: ["INVENTORY"],
				},
				{
					title: this.$t('PRICE'),
					key: 'price',
					disabled: !this.checkRoleFunc('RATE'),
					routeName: "basePriceUpdate",
					roles: ["RATE"],
				},
				{
					title: this.$t('RESTRICTION'),
					key: 'restriction',
					disabled: !this.checkRoleFunc('RESTRICTION'),
					routeName: "restrictionUpdate",
					roles: ["RESTRICTION"],
				},
				{
					title: this.$t('SELL_LIMIT'),
					key: 'stopSell',
					disabled: !this.checkRoleFunc('STOP_SELL_LIMIT'),
					routeName: "stopSellUpdate",
					roles: ["STOP_SELL_LIMIT"],
				},
			]
		}
	},
	created() {
		switch (this.$route.name) {
			case 'roomAvailUpdate':
				this.tab = 0;
				break;
			case 'basePriceUpdate':
			case 'priceRoomSpecialUpdate':
				this.tab = 1;
				break;
			case 'specialPriceUpdate':
				this.tab = 1;
				break;
			case 'priceExtraUpdate':
				this.tab = 1;
				break;
			case 'priceExtraSpecialUpdate':
				this.tab = 1;
				break;
			case 'restrictionUpdate':
				this.tab = 2;
				break;
			case 'stopSellLimit':
			case 'stopUnderSellLimit':
				this.tab = 3;
				break;
			default:
				break;
		}
	},
	watch: {
		'$route.query': 'fetchData',
	},
	methods: {
		loadRoute(routeName) {
			this.$router.push({ name: routeName });
		},
		_formatCurrency: _formatCurrency,
		formatDate: _formatDate,
	}
};
</script>
